import React from 'react';

import DefaultOverview from './DefaultOverview';
import ArticlesOverview from './ArticlesOverview';
import ActivitiesOverview from './ActivitiesOverview';
import VacanciesOverview from './VacanciesOverview';
import VacanciesPaidOverview from './VacanciesPaidOverview';
import VacanciesVolunteeringOverview from './VacanciesVolunteeringOverview';
import VacanciesDaytimeActivityOverview from './VacanciesDaytimeActivityOverview';
import PartnersOverview from './PartnersOverview';
import RentalLocationsOverview from './RentalLocationsOverview';

import './style.scss';

const CONTENT_OVERVIEW_MAPPING = {
  // Projects have no filters, so default overview
  projects: {
    component: DefaultOverview,
    display: 'block_2',
  },
  // News has article filters
  articles_news: {
    component: ArticlesOverview,
    display: 'block_5',
  },
  // Stories have article filters
  articles_stories: {
    component: ArticlesOverview,
    display: 'block_6',
  },
  // Activities have their own filters
  activities: {
    component: ActivitiesOverview,
    display: 'activities',
    targetAudience: 'participant',
  },
  activities_volunteer: {
    component: ActivitiesOverview,
    display: 'activities',
    targetAudience: 'volunteer',
  },
  // Vacancies have their own filters
  vacancies: {
    component: VacanciesOverview,
    display: 'block_4',
  },
  // Volunteering vacancies
  vacancies_volunteering: {
    component: VacanciesVolunteeringOverview,
    display: 'block_7',
  },
  // Paid vacancies
  vacancies_paid: {
    component: VacanciesPaidOverview,
    display: 'block_8',
  },
  vacancies_daytime_activity: {
    component: VacanciesDaytimeActivityOverview,
    display: 'block_9',
  },
  themes: {
    component: DefaultOverview,
    display: 'block_1',
    view: 'taxonomy_overview',
  },
  // Paid vacancies
  partners: {
    component: PartnersOverview,
    display: 'block_2',
    view: 'taxonomy_overview',
    fullWidth: true,
  },
  rental_locations: {
    component: RentalLocationsOverview,
    display: 'overview',
  },
};

const ParagraphContentOverview = ({ entity }) => {
  const type = entity.getIn(['field_type', 0, 'value'], 'projects');
  const {
    component: OverviewComponent,
    view: viewName = 'content_overview',
    ...restProps
  } = CONTENT_OVERVIEW_MAPPING[type];

  return (
    <div className="ParagraphContentOverview">
      <OverviewComponent
        viewName={viewName}
        {...restProps}
      />
    </div>
  );
};

export default ParagraphContentOverview;
